import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { USERINFO_ENDPOINT} from 'constants/values';
// Constants
// User info fetch function

async function fetchUserInfo(token) {
  const response = await fetch(USERINFO_ENDPOINT, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
 
  if (!response.ok) {
    const errorText = await response.text();
    sessionStorage.setItem('user_info_error', errorText);
    throw new Error("User info request failed");
  }
  const data = await response.json();
  sessionStorage.setItem("userId", data.bmwdcsnetuid);
  return data;

}
 
class IdpResponseHandler extends Component {

  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
    };

  }
 
  async componentDidMount() {
    const hash = window.location.hash.substr(1); // remove #
    const params = new URLSearchParams(hash);
    const accessToken = params.get('access_token');
    const idToken = params.get('id_token');
    if (accessToken && idToken) {
      sessionStorage.setItem('access_token', accessToken);
      sessionStorage.setItem('id_token', idToken);
      try {

        const userInfo = await fetchUserInfo(accessToken);
        sessionStorage.setItem('user_info', JSON.stringify(userInfo));
      } catch (err) {
        sessionStorage.setItem('Failed to fetch user info:', err);
      }
 
      // Clean up URL
      window.history.replaceState(null, '', window.location.pathname);
      // Redirect to root
      this.setState({ redirect: true });
    } else {
      sessionStorage.setItem('missing', 'params');
      this.props.history.push('/');
    }

  }
 
  render() {

    if (this.state.redirect) {
      return <Redirect to="/" />;
    }
    return <div>Processing login...</div>;
  }

}
 
export default IdpResponseHandler;

 
